import { compareCivilDate, getCivilDateDayOfWeek,
  getCivilDateMonthStart, getCivilDateMonthEnd } from '@bingads-webui-universal/temporal-utitlities';
import _ from 'underscore';
import { ComparedOptions } from './compared-options';

export const getLastMonth = (date) => {
  let lastMonthDate = date.plus({ months: -1 });
  if (lastMonthDate.day !== date.day) {
    lastMonthDate = lastMonthDate.plus({ days: -lastMonthDate.day });
  }
  return lastMonthDate;
};

export const getThisMonday = date => (getCivilDateDayOfWeek(date) === 0 ?
  date.plus({ days: -6 }) :
  date.plus({ days: -getCivilDateDayOfWeek(date) + 1 }));

export const formatMonthDayYear = (date, i18n, timeZone, dateFormat = 'M/d/yyyy') =>
  `${date ? i18n.formatCivilDate(date, { raw: dateFormat, timeZone }) : ''}`;

export const getSelectedRange = (selectedRange, specificRanges, specificRngeId) => {
  if (!specificRngeId || specificRngeId === 4) {
    return selectedRange;
  }
  const selectedSpecificRange = _.find(specificRanges, range => range.rangeId === specificRngeId);
  return selectedSpecificRange ? selectedSpecificRange.range : selectedRange;
};

export const isRangeValid = range =>
  Boolean(range.start && range.end && compareCivilDate(range.start, range.end) <= 0);

export const getComparedTypeFromRange = ({ range, comparedRange, selectedRangeId }) => {
  if (isRangeValid(range) && isRangeValid(comparedRange)) {
    const option = _.find(
      ComparedOptions,
      (op) => {
        const ran = op.get(range, selectedRangeId);
        return ran.start && ran.end && comparedRange.start && comparedRange.end
          && compareCivilDate(ran.start, comparedRange.start) === 0
          && compareCivilDate(ran.end, comparedRange.end) === 0;
      }
    );
    return option || ComparedOptions[3];
  }

  return ComparedOptions[3];
};

export const getComparedRangeFromType = ({ range, type, selectedRangeId }) =>
  _.find(ComparedOptions, option => option.type === type).get(range, selectedRangeId);

export const getStartDate = ({
  date,
  isMonthRangePicker,
  minDate,
}) => {
  if (isMonthRangePicker) {
    const monthStart = getCivilDateMonthStart(date);
    return minDate && compareCivilDate(monthStart, minDate) < 0
      ? minDate
      : monthStart;
  }
  return date;
};

export const getEndDate = ({
  date,
  isMonthRangePicker,
  maxDate,
}) => {
  if (isMonthRangePicker) {
    const monthEnd = getCivilDateMonthEnd(date);
    return maxDate && compareCivilDate(monthEnd, maxDate) > 0
      ? maxDate
      : monthEnd;
  }
  return date;
};

export const getRangeOnSelectDate = ({
  start,
  end,
  isMonthRangePicker = false,
  maxDate,
  minDate,
}) => {
  if (!end) {
    return {
      start: getStartDate({ date: start, isMonthRangePicker, minDate }),
      end: getEndDate({ date: start, isMonthRangePicker, maxDate }),
    };
  }

  if (end < start) {
    return {
      start: getStartDate({ date: end, isMonthRangePicker, minDate }),
      end: getEndDate({ date: start, isMonthRangePicker, maxDate }),
    };
  }

  return {
    start: getStartDate({ date: start, isMonthRangePicker, minDate }),
    end: getEndDate({ date: end, isMonthRangePicker, maxDate }),
  };
};
